import { faMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@pickleballinc/ui/lib/utils';

interface TeamMatchupCardProps {
	awayTeam: string;
	homeTeam: string;
	awayScore?: number;
	homeScore?: number;
	date: string;
	court: string;
	venue: string;
	status: 'coming-up' | 'live';
	className?: string;
}

export const TeamMatchupCard = ({ awayTeam, homeTeam, awayScore, homeScore, date, court, venue, status, className = '' }: TeamMatchupCardProps) => {
	const formatDateTime = (isoString: string) => {
		const dateObj = new Date(isoString);

		const formattedDate = dateObj.toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
			year: 'numeric'
		});

		const formattedTime = dateObj.toLocaleTimeString('en-US', {
			hour: 'numeric',
			minute: '2-digit',
			hour12: true,
			timeZoneName: 'short'
		});

		return `${formattedDate} | ${formattedTime}`;
	};

	const isLive = status === 'live';

	return (
		<div
			className={cn(
				'rounded-lg border p-4 relative',
				{
					'bg-darkorange-25 border-darkorange-300': isLive,
					'bg-white border-gray-200': !isLive
				},
				className
			)}
		>
			<div className="absolute top-3 right-3">
				<div className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium border bg-white border-gray-200 text-gray-700">
					<div
						className={cn('w-2 h-2 rounded-full', {
							'bg-orange-700': isLive,
							'bg-orange-500': !isLive
						})}
					/>
					<span className="hidden text-xs sm:inline">{isLive ? 'Live score' : 'Coming up!'}</span>
					<span className="sm:hidden text-xs">{isLive ? 'Live score' : 'Coming up!'}</span>
				</div>
			</div>

			<div className="mb-3 pr-20">
				<div className="text-gray-600 text-sm mb-1">{formatDateTime(date)}</div>
				<div className="text-gray-600 text-sm">Court: {court}</div>
			</div>

			<div className="space-y-2 mb-3">
				<div className="flex items-center justify-between">
					<div className="flex items-center gap-2">
						<span className="text-base font-semibold text-gray-900">{awayTeam} (A)</span>
					</div>
					<div className="text-lg font-bold text-gray-500">{awayScore !== undefined ? awayScore : '0'}</div>
				</div>

				<div className="flex items-center justify-between">
					<div className="flex items-center gap-2">
						<span className="text-base font-semibold text-gray-900">{homeTeam} (H)</span>
					</div>
					<div className="text-lg font-bold text-gray-500">{homeScore !== undefined ? homeScore : '0'}</div>
				</div>
			</div>

			<div className="flex items-center gap-1 text-gray-500 text-sm">
				<FontAwesomeIcon icon={faMapMarkerAlt} className="h-3 w-3" />
				<span>{venue}</span>
			</div>
		</div>
	);
};
